import { StoreAction } from "../../@core/constants/action";

const initialState = {
  holidaysList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case StoreAction.GET_ALL_HOLIDAYS_LIST:
      return {
        ...state,
        holidaysList: action.payload,
      };
    default:
      return state;
  }
}
